/* eslint semi:0 */
import { logout, fbLogin, unimpersonate } from '../actions/userToolbarActions'
import BaseVm from './BaseVm'
import { safeRequest } from '../../utils/mithril'

class UserToolbarVm extends BaseVm {
  fbLoginClick(e) {
    if (this.state.fbSdkReady) {
      fbLogin()
    }
  }

  logoutClick(e) {
    e.preventDefault()
    logout()
  }

  unimpersonateClick(e) {
    e.preventDefault()
    safeRequest({
      method: 'PUT',
      url: e.target.href,
    }).then(unimpersonate)
  }
}

export default UserToolbarVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/userToolbarVm.js